import type { ComponentProps } from "react";
import React from "react";

import { cn } from "@/lib/helpers/cn";
import { Link } from "@/component-library";

type EarlierAppointmentInfoProps = ComponentProps<"p">;

export const EarlierAppointmentInfo = ({ className }: EarlierAppointmentInfoProps) => (
  <p className={cn("body-md tw:text-center tw:text-text-tertiary", className)}>
    If you need an earlier appointment due to clinical urgency, please contact our team at{" "}
    {/* Empty props needs to be added to satisfy TS */}
    <Link
      className=""
      href="mailto:urgentreferral@aptihealth.com"
      onClick={undefined}
      target="_blank"
      type="apti-Link"
    >
      urgentreferral@aptihealth.com
    </Link>
  </p>
);
